import { API, Auth } from 'aws-amplify'
import React, { useState } from 'react'
import "bootstrap/dist/css/bootstrap.css";
import { Table } from '@aws-amplify/ui-react';
import KeywordRow from './KeywordRow';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { Search } from 'react-bootstrap-icons';
import Spinner from 'react-bootstrap/Spinner';

const KeywordTable = (props) => {
  const [input, setInput] = useState("")
  const [entities, setEntities] = useState({ 'items': [] })
  const [text, setText] = useState("")
  const [keyword, setKeyword] = useState("")
  const [isBusy, setIsBusy] = useState(false);
  const [pageno, setPageno] = useState("");
  const projectId = props.project_id;
  const [notFoundText, setNotFound] = useState('');

  const search = async (e) => {
    setIsBusy(true);
    setText("");
    setNotFound('');
    setEntities(null)
    const myAPI = "DocumentSearchUser"
    const user = await Auth.currentAuthenticatedUser()
    setKeyword(e.input)
    const requestInfo = { headers: { Authorization: user.signInUserSession.idToken.jwtToken } }
    API.get(myAPI, `/keywordsearch?projectid=${projectId}&keyword=${e.input}`, requestInfo)
      .then(response => {
        setIsBusy(false);
        setEntities(response.items)
        console.log(response.items)
        props.onSearch(response.report_id);
        if(response.items.items.length == 0)
          {
            setNotFound('No results found!');
          }
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error);
      })
  };

  const handleDetail = async (entity) => {
    setIsBusy(true);
    setPageno('')
    const user = await Auth.currentAuthenticatedUser()
    const requestInfo = { headers: { Authorization: user.signInUserSession.idToken.jwtToken } }
    API.get('DocumentSearchUser', '/getfilecontent' + `?projectid=${projectId}&filename=${entity.file_name}&page=${entity.page}&keyword=${keyword}`, requestInfo)
      .then(response => {
        setIsBusy(false);
        setText(response.text);
        setPageno(`Page ${response.page_no} of ${response.no_pages}`)
        console.log(response)
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error);
      })
    // setText(entity.text)
  };
  return (
    <>
      <Row>
        <Col>
          <br />
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/projects" }}>Projects</Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/files?projectid=" + projectId }}>{projectId}</Breadcrumb.Item>
            <Breadcrumb.Item active>keyword</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row>
        <Col>
          <h1 style={{ textAlign: 'center' }}>Keyword Search</h1>
        </Col>
      </Row>
      <Row>
        <Col sm="5">
          <InputGroup className="mb-3">
            <FormControl
              placeholder="enter search phrase"
              aria-label="enter search phrase"
              aria-describedby="basic-addon2"
              value={input} onChange={(e) => setInput(e.target.value)}
            />
            <Button variant="outline-secondary" id="button-addon2" onClick={() => search({ input })}>
              <Search />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          {isBusy &&
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          }
        </Col>
      </Row>
      <Row>
        <Col>
          <div key={entities?.user_id} className="float-child">
            <div style={{ "height": "50vh", "overflow-x": "hidden", "overflow-y": "auto" }}>
            <h5 style={{ color: 'red' }}>{notFoundText}</h5>
              <Table>
                <tbody>
                  {
                    entities?.items.map((thisEntity, index) => {
                      return (
                        <KeywordRow key={index} entity={thisEntity} projectId={projectId} OnDetail={handleDetail} />
                      )
                    })
                  }
                </tbody>
              </Table>
            </div>
          </div>
          <div className="float-child">
            <div id='doctextarea' style={{ "width": "100%", "height": "50vh", "padding": "20px", "overflow-y": "auto" }} readOnly dangerouslySetInnerHTML={{ __html: text }}></div>
            <div style={{ textAlign: 'right' }}>
              {pageno}
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}
export default KeywordTable;